import styled, { keyframes } from 'styled-components'
import { breakpoints } from '@awaze/design-system.utils.react'

export const StyledSkeletonLoader = styled.div`
  box-shadow:
    0 0.3px 0.5px 0 rgba(0, 0, 0, 0.1),
    0 2px 4px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  overflow: hidden;
  display: grid;
  grid-template-rows: auto 340px;
  background-color: ${({ theme }) => theme.ColorWhiteOpacity50};

  > div:first-of-type {
    aspect-ratio: 375/288;

    @media only screen and (min-width: ${breakpoints[0]}px) {
      grid-row: 1 / span 2;
      aspect-ratio: auto;
    }
  }

  @media only screen and (min-width: ${breakpoints[0]}px) {
    grid-template-columns: 300px 1.8fr 1fr;
    grid-template-rows: 189px 72px;
  }
`

export const StyledSkeletonContent = styled.div`
  display: grid;
  grid-template-rows: 64px auto 64px;
  grid-row: 2;
  gap: 16px 0;
  padding: 16px;

  > div {
    border-radius: 4px;
    overflow: hidden;
  }

  @media only screen and (min-width: ${breakpoints[0]}px) {
    grid-template-columns: subgrid;
    grid-template-rows: subgrid;
    grid-column: 2 / span 2;
    grid-row: 1 / span 2;
    gap: 16px;

    > div:nth-child(1) {
      grid-column: 1;
      grid-row: 1;
    }

    > div:nth-child(2) {
      grid-column: 2;
      grid-row: 1 / span 2;
    }

    > div:nth-child(3) {
      grid-column: 1;
      grid-row: 2;
    }
  }
`
const animation = keyframes`
   100% { transform: translateX(100%) }
`

export const StyledSkeletonGradient = styled.div`
  background-color: ${({ theme }) => theme.ColorGrey100};
  position: relative;
  overflow: hidden;
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0)
    );
    animation: ${animation} 2s infinite;
    content: '';
  }
`
